import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "24",
      height: "24",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 0h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#114A4E",
        d: "m11.25 11.1-1.923 1.923a.71.71 0 0 1-.53.22.75.75 0 0 1-.54-.235.78.78 0 0 1-.224-.527.7.7 0 0 1 .225-.527l3.11-3.11A.83.83 0 0 1 12 8.588q.18 0 .336.058a.8.8 0 0 1 .297.198l3.11 3.11a.7.7 0 0 1 .22.522.77.77 0 0 1-.22.532.76.76 0 0 1-.535.24.7.7 0 0 1-.535-.225L12.75 11.1v7.65a.73.73 0 0 1-.215.535.73.73 0 0 1-.535.215.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535zM4.5 8.27V6.307q0-.758.525-1.283T6.308 4.5h11.384q.758 0 1.283.525t.525 1.283v1.961a.73.73 0 0 1-.215.535.73.73 0 0 1-.535.215.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535V6.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v1.961a.73.73 0 0 1-.215.535.73.73 0 0 1-.535.215.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535"
      })
    ], -1)
  ])))
}
export default { render: render }